<template>
  <el-dialog
    title="Edit campaign"
    :visible="editDialog"
    width="500px"
    top="3vh"
    :modal="true"
    custom-class="campaignModal"
    @close="closeModal"
    @open="openModal"
    :close-on-click-modal="false"
  >
    <el-form ref="track" :model="track" label-position="top">
      <el-form-item label="Campaign End" prop="campaign_end">
        <el-date-picker
          v-model="track.campaign_track_end"
          type="date"
          unlink-panels
          range-separator="-"
          placeholder="Campaign end"
          :picker-options="dateRangeOptions"
          format="d MMMM yyyy"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item  prop="track_active">
        <el-checkbox label="Active" v-model="active"></el-checkbox>
      </el-form-item>
      <el-form-item label="Tier Timeout" prop="tierTimeout">
        <el-input-number v-model="track.bronze_tier_timeout" clearable :min="0"/>
      </el-form-item>
      <el-form-item label="Campaign Package" prop="campaign_package">
        <el-select v-model="track.campaign_packages_id" clearable filterable>
          <el-option
              v-for="c in campaign_packages"
              :key="c.id"
              :value="c.id"
              :label="`${c.name}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Bands" prop="bands">
        <el-checkbox-group v-model="bands" class="bands-group">
          <el-checkbox-button label="A" >A</el-checkbox-button>
          <el-checkbox-button label="B" >B</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <div v-if="track.campaign_packages_id === 2">
        <el-form-item label="YouTube Category">
          <el-select v-model="track.youtube_categories" multiple collapse-tags
                     placeholder="Select category" :multiple-limit="5" filterable>
            <el-option v-for="category in youtubeCategories" :key="category.id"
                :label="category.name" :value="category.id">
            </el-option>
          </el-select>
        </el-form-item>
        <label class="subscriber-reach">
          Subscriber Reach
          <el-button v-if="track.subscriberReach" @click="track.subscriberReach = null"
                     icon="el-icon-refresh" class="refresh-btn" circle></el-button>
        </label>
        <el-radio v-for="(option, i) in subscriberOptions" :key="option"
                  v-model="track.subscriberReach" :label="option">
          {{ i === subscriberOptions.length - 1 ? option + '+'  : option }}K
        </el-radio>
        <div class="mb10"></div>
        <el-form-item label="Categories and Subscribers - days">
          <el-date-picker v-model="track.youtubeCategoryDays" type="date" placeholder="Select date"
                          :picker-options="pickerOptions" :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">
          </el-date-picker>
        </el-form-item>
      </div>
      <el-form-item label="Balance" prop="balance">
        <div class="balance-action">
          <el-input-number v-model="track.balance" clearable :precision="2" :min="0" :step="0.1"/>
          <el-radio-group v-model="track.balanceAction" class="ml10">
            <el-radio-button label="add">Add</el-radio-button>
            <el-radio-button label="subtract">Subtract</el-radio-button>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-radio v-model="track.bonusType" label="standard">
        TopUp ({{ track.bonuses ? (track.bonuses['standard'] / 10).toFixed(2) : 0 }})
      </el-radio>
      <el-radio v-model="track.bonusType" label="bonus">
        Bonus ({{ track.bonuses ? (track.bonuses['bonus'] / 10).toFixed(2) : 0 }})
      </el-radio>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="callEditTrack">
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  data() {
    return {
      subscriberOptions: ['0-10', '10-50', '50-100', '100-200', '200'],
      bands: []
    }
  },
  computed: {
    ...mapState('vcTrack', ['track', 'editDialog', 'campaign_packages', 'youtubeCategories']),
    active: {
      get() {
        return Boolean(this.$store.state.vcTrack.track.active)
      },
      set(val) {
        this.$store.commit('vcTrack/setActive', val)
      }
    },
    pickerOptions() {
      const vm = this
      return {
        disabledDate(time) {
          const today = new Date();

          return (time.getTime() >= new Date(vm.track.campaign_track_end).getTime())
            || time.getTime() < today.setDate(today.getDate() - 1)
        }
      }
    }
  },
  methods: {
    ...mapMutations('vcTrack', ['setEditDialog', 'setTrack']),
    ...mapActions('vcTrack', ['editTrack', 'readCampaignPackages']),
    openModal() {
      this.readCampaignPackages()
      this.track.youtube_categories = this.track.youtube_categories.map(c => c.id)
      this.bands = []
      if(this.track.band == 1){
        this.bands.push("A")
      }
      if(this.track.band == 2){
        this.bands.push("B")
      }
    },
    closeModal() {
      this.setEditDialog(false)
      this.setTrack({})
    },
    callEditTrack(){
      if(this.bands.includes('A') && this.bands.includes('B')){
        this.track.bands = 3;
      }
      else if(this.bands.includes('A')){
        this.track.bands = 1;
      }
      else if(this.bands.includes('B')){
        this.track.bands = 2;
      }
      else{
        this.track.bands = 0;
      }
      if((this.track.bands == 1 ||this.track.bands == 3) && this.track.balance < 500){
        this.$msgbox('Minimum budget for this campaign is $500', 'Error')
      }
      else if(this.track.bands == 2 && this.track.balance < 250){
        this.$msgbox('Minimum budget for this campaign is $250', 'Error')
      }
      else{
        this.editTrack()
      }
    }
  }
}
</script>

<style lang="scss">

.campaignModal {
  .el-radio {
    margin-right: 10px;
    color: #0E0525;
    display: inline-flex;
  }

  .el-dialog__body {
    padding: 0 40px;
  }

  .subscriber-reach {
    text-align: left;
    word-break: break-word;
    font-size: 16px;
    color: #0E0525;
    line-height: 23px;
    min-height: 45px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .refresh-btn {
      height: 25px;
      width: 25px;
      padding: 0;
      margin-left: 5px;
    }
  }
  .balance-action {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .bands-group{
    display: inline-flex;
  }
}
</style>
